<style lang="postcss">
  .confidentialBadge {
    display: inline-block;
    padding: 0.25rem 0.5rem;
    border-radius: var(--ubilabs-border-radius-medium);
    background-color: var(--ubilabs-red-dark-2);
    color: var(--ubilabs-white);
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 1px;
    pointer-events: none;
  }
</style>

<div class="confidentialBadge {$$props.class}">Confidential</div>
